import { Container, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Astro from './astro.svg'
import RM2 from '../RM2/RM2'

export default function RoadMap() {
  return (
    <>
      <Box mt={10} id="roadMap">
        <Container>
          <RM2 />
        </Container>
        <Box
          style={{
            textAlign: 'left',
            width: '100%',
            maxWidth: '1550px',
            margin: 'auto',
          }}
        >
          <img src={Astro} alt={Astro} width="20%" />
        </Box>
      </Box>
    </>
  )
}
